<div class="password-strength-container">
  <div
    class="password-strength-item"
    [class.valid]="hasMinimumLength"
  >
    <ng-icon
      [name]="hasMinimumLength ? 'matCheckCircle' : 'matCircle'"
    ></ng-icon>
    <span translate>Minimum 8 characters</span>
  </div>
  <div
    class="password-strength-item"
    [class.valid]="hasLowerCase"
  >
    <ng-icon [name]="hasLowerCase ? 'matCheckCircle' : 'matCircle'"></ng-icon>
    <span translate>At least one lowercase letter</span>
  </div>
  <div
    class="password-strength-item"
    [class.valid]="hasUpperCase"
  >
    <ng-icon [name]="hasUpperCase ? 'matCheckCircle' : 'matCircle'"></ng-icon>
    <span translate>At least one uppercase letter</span>
  </div>
  <div
    class="password-strength-item"
    [class.valid]="hasDigit"
  >
    <ng-icon [name]="hasDigit ? 'matCheckCircle' : 'matCircle'"></ng-icon>
    <span translate>At least one digit</span>
  </div>
  <div
    class="password-strength-item"
    [class.valid]="hasSpecialChar"
  >
    <ng-icon [name]="hasSpecialChar ? 'matCheckCircle' : 'matCircle'"></ng-icon>
    <span translate>At least one special character</span>
  </div>
</div>
